removeUserProfileImages